import Job from '../../jobs/types/job';
import FiltersState, { ExecutableFilter, FilterState } from '../state/filters-state';

const hasSelected = (object: any): object is FilterState<any> => 'selected' in object;

const hasFilter = (object: any): object is ExecutableFilter<any> => 'filterFunction' in object;

const useFilters = (jobs: Job[], filters: FiltersState): Job[] => {
  let filtered = jobs;

  // eslint-disable-next-line no-restricted-syntax
  for (const [, filterState] of Object.entries(filters)) {
    const selected = hasSelected(filterState) ? filterState.selected : [];
    const filterFunction = hasFilter(filterState) ? filterState.filterFunction : undefined;
    filtered = typeof filterFunction !== 'undefined' ? filterFunction(filtered, selected) : filtered;
  }

  return filtered;
};

export default useFilters;
